import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-carousel',
  templateUrl: './about-carousel.component.html',
  styleUrls: ['./about-carousel.component.scss']
})
export class AboutCarouselComponent implements OnInit {

  constructor() { }

  services = [
    {
      imageUrl: '../../../../assets/images/screen.svg',
      title: '55',
      desc: 'End To End Projects Developed',
    },
    {
      imageUrl: '../../../../assets/images/upload.svg',
      title: '20',
      desc: 'Brands Developed',
    },
    {
      imageUrl: '../../../../assets/images/screen.svg',
      title: '70',
      desc: 'Clients Served',
    },
    {
      imageUrl: '../../../../assets/images/touch.svg',
      title: '100',
      desc: 'Team Members',
    },

  ]


  ngOnInit(): void {
  }


}
